<template>
  <v-tabs
    centered
    :grow="$vuetify.breakpoint.smAndDown"
    :show-arrows="$vuetify.breakpoint.xs ? true : false"
    :value="active"
    color="secondary"
    v-if="active != null"
    class="tabsGeneralStyle"
  >
    <v-tab
      v-for="item in items"
      :key="item.id"
      :disabled="item.disabled"
      @click="handleClick($event, item)"
    >
      {{ item.text }}
    </v-tab>
  </v-tabs>
</template>

<script>
import { instance as axiosAuth } from "@/api/axios-auth";

export default {
  name: "moduleNavigation",

  props: {
    refresh_dialog_nav_loading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      items: [
        {
          id: 0,
          text: "Bearbeiten",
          clicked: false,
          disabled: true,
        },
        {
          id: 1,
          text: "Trainieren",
          clicked: false,
          disabled: true,
        },
        {
          id: 2,
          text: "Testen",
          clicked: false,
          disabled: true,
        },
        {
          id: 3,
          text: "Teilen",
          clicked: false,
          disabled: true,
        },
        {
          id: 4,
          text: "Analyse",
          clicked: false,
          disabled: true,
        },
      ],
    };
  },

  mounted() {
    if (this.$store.state.survey_data != null) {
      let survey_data = this.$store.state.survey_data;
      this.items.forEach(function (item) {
        switch (item.id) {
          //config
          case 0:
            item.disabled = survey_data.bearbeiten == 0;
            break;
          // intrance
          case 1:
            item.disabled = survey_data.intrance == 0;
            break;
          // testen
          case 2:
            item.disabled = survey_data.testen == 0;
            break;
          // sharing
          case 3:
            item.disabled = survey_data.live_switch == 0;
            break;
          // analyse
          case 4:
            item.disabled = survey_data.analyse == 0;
            break;
        }
      });
    }
  },

  watch: {
    survey_data() {
      if (this.$store.state.survey_data != null) {
        let survey_data = this.$store.state.survey_data;
        this.items.forEach(function (item) {
          switch (item.id) {
            //config
            case 0:
              item.disabled = survey_data.bearbeiten == 0;
              break;
            // intrance
            case 1:
              item.disabled = survey_data.intrance == 0;
              break;
            // testen
            case 2:
              item.disabled = survey_data.testen == 0;
              break;
            // sharing
            case 3:
              item.disabled = survey_data.live_switch == 0;
              break;
            // analyse
            case 4:
              item.disabled = survey_data.analyse == 0;
              break;
          }
        });
      }
    },
  },

  computed: {
    survey_data() {
      return this.$store.state.survey_data;
    },

    survey_id() {
      const route = this.$router.currentRoute;
      return parseInt(route.params.survey_id);
    },

    active() {
      switch (this.$route.name) {
        case "configurator":
          return 0;
        case "Intrance":
          return 1;
        case "Assess":
          return 2;
        case "Share":
          return 3;
        case "Analyse":
          return 4;
        default:
          return null;
      }
    },
  },

  methods: {
    async handleClick(event, item) {
      // abort if the item is already active
      if (item.id === this.active) {
        return;
      }
      // else navigate to the clicked item
      if (item.id === 0) {
        this.$router.push({
          name: "configurator",
        });
      } else if (item.id === 1) {
        this.$router.push({
          name: "Intrance",
        });
      } else if (item.id === 2) {
        this.$router.push({
          name: "Assess",
        });
      } else if (item.id === 3) {
        this.$router.push({
          name: "Share",
        });
      } else if (item.id === 4) {
        event.preventDefault();
        // check with BE if survey is multichat or not
        await axiosAuth
          .get(`/api/find_dialogmanager_status/` + this.survey_id)
          .then((response) => {
            if (
              response.data.msg === "success" &&
              response.data.connected_status.dialog_manager_id
            ) {
              this.$router.push({
                name: "AnalyseMultiChat",
                params: {
                  dialog_manager_id:
                    response.data.connected_status.dialog_manager_id,
                },
              });
            } else {
              this.$router.push({
                name: "Analyse",
                params: {
                  survey_id: this.survey_id,
                },
              });
            }
          })
          .catch((error) => {
            this.$store.dispatch("error_alert", error);
          });
      }
    },
  },
};
</script>

<style scoped>
.tabsGeneralStyle {
  max-width: 550px;
}

@media only screen and (max-width: 960px) {
  .tabsGeneralStyle {
    max-width: 100%;
  }
}

.mobile .tabsGeneralStyle {
  max-width: 100%;
}
</style>
